export default "__VITE_ASSET__C93Q73tL__"